/* =====================================================
   OLIVIA MADRID — Cart Upsell Section
   Broadcast theme - evento nativo theme:product:added
   ===================================================== */

(function () {
  const COLLECTION_HANDLE = 'upsell-cart';
  const FETCH_LIMIT = 50;
  const MAX_UPSELLS = 4;
  const SECTION_ID = 'om-cart-upsell';

  let allProducts = [];
  let pendingReplacement = null;

  async function fetchUpsellProducts() {
    try {
      const res = await fetch(`/collections/${COLLECTION_HANDLE}/products.json?limit=${FETCH_LIMIT}`);
      if (!res.ok) return [];
      const data = await res.json();
      return data.products || [];
    } catch (e) {
      return [];
    }
  }

  function shuffle(arr) {
    const a = [...arr];
    for (let i = a.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [a[i], a[j]] = [a[j], a[i]];
    }
    return a;
  }

  function formatPrice(price) {
    return parseFloat(price).toFixed(2).replace('.', ',') + ' €';
  }

  function renderItem(p) {
    const variant = p.variants[0];
    const src = p.images[0] ? p.images[0].src : '';
    const img = src ? src.replace(/(\.(jpg|png|webp))(\?|$)/, '_200x200$1$3') : '';
    const hasCompare = variant.compare_at_price && parseFloat(variant.compare_at_price) > parseFloat(variant.price);

    const el = document.createElement('div');
    el.className = 'om-upsell-item';
    el.dataset.variantId = variant.id;
    el.innerHTML = `
      <div class="om-upsell-img">
        ${img ? `<img src="${img}" alt="${p.title}" loading="lazy" />` : '<div class="om-upsell-img-placeholder"></div>'}
      </div>
      <div class="om-upsell-info">
        <p class="om-upsell-name">${p.title}</p>
        <p class="om-upsell-price">
          <span class="om-upsell-price-current">${formatPrice(variant.price)}</span>
          ${hasCompare ? `<span class="om-upsell-price-compare">${formatPrice(variant.compare_at_price)}</span>` : ''}
        </p>
      </div>
      <button class="om-upsell-btn" data-variant-id="${variant.id}">+ Añadir</button>`;

    el.querySelector('.om-upsell-btn').addEventListener('click', () => addToCart(variant.id, el));
    return el;
  }

  async function addToCart(variantId, itemEl) {
    const btn = itemEl.querySelector('.om-upsell-btn');
    btn.disabled = true;
    btn.textContent = '...';

    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 }),
      });
      if (!res.ok) throw new Error();

      const addedItem = await res.json();
      pendingReplacement = variantId;

      // Anima saída do item atual
      itemEl.style.transition = 'opacity 0.3s ease';
      itemEl.style.opacity = '0';

      // Dispara o evento nativo do Broadcast — ele atualiza tudo: itens, total, descontos
      document.dispatchEvent(new CustomEvent('theme:product:added', {
        bubbles: true,
        detail: { product: addedItem }
      }));

      // Após o Broadcast fazer o refresh, o observer reinjetar os upsells automaticamente
      // mas precisamos de guardar qual produto substituir
      setTimeout(() => {
        const excludeIds = new Set([pendingReplacement].filter(Boolean));
        const next = allProducts.find(p =>
          !p.variants.some(v => excludeIds.has(v.id))
        );

        if (next && itemEl.parentNode) {
          const newEl = renderItem(next);
          newEl.style.opacity = '0';
          itemEl.parentNode.replaceChild(newEl, itemEl);
          setTimeout(() => {
            newEl.style.transition = 'opacity 0.3s ease';
            newEl.style.opacity = '1';
          }, 50);
        } else if (itemEl.parentNode) {
          itemEl.remove();
        }
      }, 300);

    } catch (e) {
      btn.textContent = '+ Añadir';
      btn.disabled = false;
    }
  }

  function injectUpsells(cartVariantIds) {
    const existing = document.getElementById(SECTION_ID);
    if (existing) existing.remove();

    const excludeIds = new Set([...cartVariantIds, pendingReplacement].filter(Boolean));

    const available = shuffle(allProducts.filter(p =>
      !p.variants.some(v => excludeIds.has(v.id))
    ));

    if (available.length === 0) return;

    const selected = available.slice(0, MAX_UPSELLS);

    const section = document.createElement('div');
    section.id = SECTION_ID;
    section.className = 'om-cart-upsell';

    const title = document.createElement('p');
    title.className = 'om-upsell-title';
    title.textContent = 'También te puede gustar';

    const list = document.createElement('div');
    list.className = 'om-upsell-list';

    selected.forEach(p => list.appendChild(renderItem(p)));
    section.appendChild(title);
    section.appendChild(list);

    const drawerBody = document.querySelector('[data-cart-drawer-body]');
    const drawerFoot = document.querySelector('[data-checkout-buttons]');
    let container = drawerBody;

    if (!container) {
      for (const sel of ['.cart-drawer__inner', '[data-cart-drawer-inner]', '#cart-drawer .drawer__body']) {
        container = document.querySelector(sel);
        if (container) break;
      }
    }

    if (!container) return;

    if (drawerFoot && drawerFoot.parentNode === container) {
      container.insertBefore(section, drawerFoot);
    } else {
      container.appendChild(section);
    }

    pendingReplacement = null;
  }

  async function init() {
    const drawer = document.getElementById('cart-drawer');
    if (!drawer) return;

    if (!allProducts.length) {
      allProducts = await fetchUpsellProducts();
    }
    if (!allProducts.length) return;

    const cartRes = await fetch('/cart.js').then(r => r.json()).catch(() => ({ items: [] }));
    const cartVariantIds = (cartRes.items || []).map(i => i.variant_id);
    injectUpsells(cartVariantIds);
  }

  function setupListeners() {
    ['cart:open', 'drawer:open', 'cart-drawer:open'].forEach(evt => {
      document.addEventListener(evt, () => setTimeout(init, 400));
    });

    // Observer — reinjetar quando o Broadcast recria o drawer após theme:product:added
    const observer = new MutationObserver(() => {
      const drawer = document.getElementById('cart-drawer');
      if (!drawer) return;
      const isOpen = drawer.classList.contains('is-open') || drawer.hasAttribute('open');
      if (isOpen && !document.getElementById(SECTION_ID)) {
        setTimeout(init, 700);
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class', 'open']
    });

    document.querySelectorAll('[data-cart-toggle], [data-cart-open], .navlink--cart').forEach(el => {
      el.addEventListener('click', () => setTimeout(init, 600));
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupListeners);
  } else {
    setupListeners();
  }
})();